import React, {Component} from 'react';
import ScrollArea from 'react-scrollbar';

class ColoredScrollbars extends Component {

    render() {
        return (
            <ScrollArea
            speed={0.8}
            className="area h-100"
            contentClassName="view projects-list"
            horizontal={false}
            {...this.props}/>

        );
    }
}
export default ColoredScrollbars;



// WEBPACK FOOTER //
// ./src/pages/ColoredScrollbars.js